import { deprecatedSortOptions } from '@gonfalon/dogfood-flags/dogfood-flags';

/**
 * Single source of truth for deprecated sort keys.
 * These sorts are being phased out as of v4 of the API.
 */
export const deprecatedSortKeys = ['targetingModifiedDate', '-targetingModifiedDate'] as const;

export type DeprecatedSortKey = (typeof deprecatedSortKeys)[number];

/**
 * Check if a specific deprecated sort is currently enabled.
 * Returns true if the sort should be included, false if it should be omitted.
 */
export function isDeprecatedSortEnabled(key: DeprecatedSortKey): boolean {
  if (['targetingModifiedDate', '-targetingModifiedDate'].includes(key)) {
    return deprecatedSortOptions().targetingModifiedDate;
  }
  return true;
}
